export default (theme) => ({
  textField: {
    width: '100%',
    lineHeight: 1.4,
    '& .MuiOutlinedInput-root': {
      boxSizing: 'border-box',
      height: 32,
    },
  },
  inlineFlex: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    alignItems: 'center',
  },
  inputButton: {
    padding: '2px 8px',
    minWidth: 'auto',
    lineHeight: 1.4,
    color: theme.palette.textColor.secondary,
    '&:hover': {
      color: theme.palette.textColor.secondary,
    },
    '&:focus': {
      color: theme.palette.textColor.secondary,
    },
  },
  primaryButton: {
    color: theme.palette.textColor.primary,
    '&:hover': {
      color: theme.palette.textColor.primary,
    },
    '&:focus': {
      color: theme.palette.textColor.primary,
    },
  },
  addButton: {
    padding: 4,
    paddingLeft: 12,
    minWidth: 'auto',
    height: 32,
    color: theme.palette.textColor.primary,
    textTransform: 'none',
    '&:hover': {
      color: theme.palette.textColor.primary,
      background: 'transparent',
    },
    '&:focus': {
      color: theme.palette.textColor.primary,
      background: 'transparent',
    },
  },
  option: {
    fontSize: 14,
    '&:hover $iconButton': {
      visibility: 'visible',
    },
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  rowLabel: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  rowActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexShrink: 0,
  },
  // the caller renders the selection itself (chips), so the field keeps showing its placeholder
  hiddenTags: {
    '& .MuiChip-root': {
      display: 'none',
    },
  },
  iconButton: {
    visibility: 'hidden',
    // sized to the label's line box so revealing it never grows the option row
    '&.MuiButton-root': {
      minWidth: 16,
      width: 16,
      height: 16,
      padding: 0,
    },
  },
  optionsIcons: {
    width: 10,
    height: 10,
  },
  checkbox: {
    padding: 0,
    marginRight: 6,
  },
});
